module.exports = __webpack_public_path__ + "img/DisplayX1031.172c5fcd.svg";